var utils = require('../../utils')

export default {
  name: 'facility-person-list',
  data: function () {
    return {
      shopList: [],
      showTabs: true,
      showTablists: true,
      showShops: true,
      showLists: true,
      showButtons: true,
      nextUrl: null,
      facilityId: null,
      facilityPersonName: '',     // 個人宅名
      dealEnds: false,          // 取引中止先を検索するか
      telDuplicateCheck: false, // 電話番号重複チェック
      isNoneData: false,        // データなし
      searchCallbackFlag: false, // 検索結果フラグ
      utils: utils,
      watchScroll: null,
      isCheckedAll: false,      // 全選択フラグ
      // ソート
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'facility_name_furigana': {'state': true,  'order': true},
        // 'facility_type':          {'state': false, 'order': false},
        'tel':                    {'state': false, 'order': false}
      },
      sortStateInit: {},
      maxShopCount: 8
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.facilitiesSearchParams !== null) {
        this.$store.getters.facilitiesSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.facilitiesSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.autocompleteEventRemove({$: $, elem:'#facility_person_name_autocomplete'}) // オートコンプリートイベント削除
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created () {
    var readMore = false

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    if (this.$store.getters.canManage) {
      // 店舗ID
      this.shopId = this.$store.getters.currentShopId
    }
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    if (this.$router.currentRoute.query.type === 'create_report') {
      this.showTabs = false
      this.showTablists = false
      this.showShops = false
      this.showLists = false
    }
    if (this.$router.currentRoute.query.type === 'reports_history') {
      this.showTablists = false
      this.showShops = false
      this.showLists = false
      var ssFacilityPersonName = window.sessionStorage.getItem("rhp-facilityPersonName")
      if (ssFacilityPersonName !== null) {
        this.facilityPersonName = ssFacilityPersonName
      }
    }
    if (this.$router.currentRoute.query.type === 'select_facility') {
      this.showTabs = false
      this.showButtons = false
      var ssShopID = window.sessionStorage.getItem("sfp-shopID")
      var ssFacilityPersonName = window.sessionStorage.getItem("sfp-facilityPersonName")
      var ssDealEnds = window.sessionStorage.getItem("sfp-dealEnds")
      var ssSortKey = window.sessionStorage.getItem("sfp-sortKey")
      var ssSortStateOrder = window.sessionStorage.getItem("sfp-sortStateOrder")
      if (!!ssShopID) {
        if (ssShopID === 'null') {
          this.shopId = null
        } else {
          this.shopId = ssShopID
        }
      }
      if (!!ssFacilityPersonName) {
        this.facilityPersonName = ssFacilityPersonName
      }
      if (!!ssDealEnds) {
        this.dealEnds = Boolean(ssDealEnds)
      }
      if (!!ssSortKey) {
        var key = ssSortKey
        this.sortKey = key
        if (ssSortStateOrder != null) {
          if (ssSortStateOrder === "true") {
            this.sortStateOrder = true
          } else {
            this.sortStateOrder = false
          }
        } else {
          this.sortStateOrder = !this.sortState[key].order
        }
        for (var k in this.sortState) {
          this.sortState[k].state = false
          if (k !== key) {
            this.sortState[k].order = false
          }
        }
        this.sortState[key].state = true
        this.sortState[key].order = this.sortStateOrder
      }
    }
    this.search(readMore)

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#facility_person_name_autocomplete',
      search:             this.search,
      searchParams:       false,
      searchAutocomplete: this.getFacilities,
      setSearchData:      this.setSearchFacility,
      clear:              this.clearFacilitiesAutocomplete,
    })

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  mounted () {
    if (this.$router.currentRoute.query.type === 'select_facility') {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
  },
  computed: {
    orderedFacilityPersons () {
      return this.facilities
    },
    /** 通知 */
    notify () {
      return this.$store.getters.facilityEditNotify
    },
    facilities () {
      return this.$store.getters.facilities
    },
    facilitiesAutocomplete() {
      return this.$store.getters.facilitiesAutocomplete
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    nextPage () {
      return this.$store.getters.facilitiesNextPage
    },
    totalCount () {
      return this.$store.getters.facilitiesTotalCount
    },
    currentPage () {
      return this.$store.getters.facilitiesCurrentPage
    },
    shops () {
      return this.$store.getters.shops
    },
    overShopCount () {
      if (this.shopList.length > this.maxShopCount) {
        return true
      }
      return false
    }
  },
  methods: {
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type}})
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type}})
    },
    goClinics: function() {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type}})
    },
    goCareOffices: function() {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type}})
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type}})
    },
    goFacilityRegister: function () {
      this.$router.push({ path: '/facility_persons/edit', query: { type: this.$router.currentRoute.query.type}})
    },
    goNext: function (id) {
      if (this.$router.currentRoute.query.type === 'reports_history') {
        this.$router.push({ path: '/reports/history/facility_person/' + id, query: {type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'select_facility') {
        var selected = this.getCheckBoxSelected()
        this.$router.push({ path: '/facility_persons/detail/' + id, query: { type: this.$router.currentRoute.query.type}})
      }
    },
    goPrev: function() {
      if (this.$router.currentRoute.query.type === 'create_report') {
        this.$router.push({path: '/', query: {type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'reports_history') {
        this.$router.push({path: '/', query: {type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'select_facility') {
        this.$router.push({path: '/' })
      }
    },
    onChecked: function (event) {
      this.isCheckedAll = false
      if (event) {
        var target = event.target
        this.$store.dispatch('FACILITY_CHECKED', { facility_id: target.value, checked: target.checked })
      }
    },
    onClickSurrounding: function () {
      // 全選択＋次ページ以降があれば再取得
      if (this.isCheckedAll && utils.isPresent(this.$store.getters.facilitiesNextPage)) {
        var data = {
          'shop_id':             this.shopId,
          'facility_name':       this.facilityPersonName,
          'facility_all':        "0",
          'facility_person':     "1",
          'deal_ends':           this.dealEnds ? "1" : "0",
          'tel_duplicate_check': this.telDuplicateCheck ? "1" : "0",
          'order':               this.orderByString()
        }
        this.$store.dispatch('FACILITY_SEARCH_ALL', {data: data, callback: this.goSurrounding})
      } else {
        this.goSurrounding()
      }
    },

    goSurrounding: function (data) {
      var selected = this.getCheckBoxSelected(data)

      this.$store.dispatch('FACILITY_SELECT', {selected: selected, callback: () => {
        this.$router.push({ path: '/facility_persons/surrounding', query: { type: this.$router.currentRoute.query.type}})
      }})
    },
    getCheckBoxSelected: function (data) {
      var elm = document.querySelectorAll('input.facility-checkbox')
      var ids = []
      var excludes = []

      Array.prototype.map.apply(elm, [function (e) {
        if (e.checked) {
          ids.push(utils.str2int(e.value))
        } else {
          excludes.push(utils.str2int(e.value))
        }
      }])
      var selected = []
      for (var i = 0; i < ids.length; i++) {
        for (var j = 0; j < this.facilities.length; j++) {
          if (utils.str2int(this.facilities[j].id) === ids[i]) {
            selected.push(this.facilities[j])
            break
          }
        }
      }
      if (data != null) {
        for (var f of data.data) {
          var id = utils.str2int(f.id)
          if (ids.indexOf(id) == -1 && excludes.indexOf(id) == -1) {
            selected.push(f)
          }
        }
      }

      this.$store.getters.facilitiesSearchParams['isCheckedAll'] = this.isCheckedAll
      this.$store.getters.facilitiesSearchParams['facilitySelected'] = selected
      return selected
    },

    setSearchFacility: function (facilityId, facilityPersonName) {
      this.facilityPersonName = facilityPersonName
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', 100)
    },
    clearFacilities: function () {
      this.$store.dispatch('FACILITY_CLEAR', 0)
    },
    clearFacilitiesAutocomplete: function () {
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', 500)
    },
    getFacilities: function () {
      this.facilityId = null
      this.search(false, 'autocomplete')
    },
    /** 電話番号重複検索 */
    telDuplicateSearch: function() {
      this.telDuplicateCheck = !this.telDuplicateCheck
      this.search(false)
    },
    /** 施設検索 (個人宅のみ) */
    search: function(readMore, mode) {
      var url = null
      var clear = true
      var autocomplete = false
      var loadparams = true
      var send_fails = 0
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.facilitiesSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.facilitiesSearchParams['scrollHeight']
        this.$store.getters.facilitiesSearchParams['pageYOffset'] = null
        this.$store.getters.facilitiesSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
        if ('isCheckedAll' in this.$store.getters.facilitiesSearchParams) {
          if (this.$store.getters.facilitiesSearchParams['isCheckedAll'] !== null) {
            this.isCheckedAll = this.$store.getters.facilitiesSearchParams['isCheckedAll']
            this.$store.getters.facilitiesSearchParams['isCheckedAll'] = null
          }
        }
      } else if (readMore) {
        // 次ページ
        url   = this.$store.getters.facilitiesNextPage
        clear = false
        loadparams = 'block'
      } else {
        // 通常またはオートコンプリート
        if (mode !== 'autocomplete') {
          this.searchCallbackFlag = false
          this.isCheckedAll = false
        }
        if (mode === 'autocomplete') {
          autocomplete = true
          clear = false
          loadparams = false
        }
      }

      if (mode !== 'autocomplete') {
        if (this.$router.currentRoute.query.type === 'reports_history') {
          send_fails = 1
        }
      }

      var selected = null
      if (this.$store.getters.facilitiesSearchParams) {
        if (this.$store.getters.facilitiesSearchParams['facilitySelected'] !== null) {
          selected = this.$store.getters.facilitiesSearchParams['facilitySelected']
          self.$store.getters.facilitiesSearchParams['facilitySelected'] = null
        }
      }
      var callback = function () {
        if (selected) {
          if (selected.length > 0) {
            for (var i = 0; i < selected.length; i++) {
              self.$store.dispatch('FACILITY_CHECKED', { facility_id: selected[i].id, checked: true})
            }
          }
        }
        self.searchCallbackFlag = true
      }
      var data = {
        'shop_id':             this.shopId,
        'facility_name':       this.facilityPersonName,
        'facility_all':        "0",
        'facility_person':     "1",
        'send_fails':          send_fails,
        'deal_ends':           this.dealEnds ? "1" : "0",
        'tel_duplicate_check': this.telDuplicateCheck ? "1" : "0",
        'order':               this.orderByString(),
        'type':                this.$router.currentRoute.query.type
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      if (this.$router.currentRoute.query.type === 'reports_history') {
        if (!!this.facilityPersonName) {
          window.sessionStorage.setItem("rhp-facilityPersonName", this.facilityPersonName)
        } else {
          window.sessionStorage.removeItem("rhp-facilityPersonName")
        }
      }
      if (this.$router.currentRoute.query.type === 'select_facility') {
        window.sessionStorage.setItem("sfp-shopID", this.shopId)
        if (!!this.facilityPersonName) {
          window.sessionStorage.setItem("sfp-facilityPersonName", this.facilityPersonName)
        } else {
          window.sessionStorage.removeItem("sfp-facilityPersonName")
        }
        if (this.dealEnds == true) {
          window.sessionStorage.setItem("sfp-dealEnds", this.dealEnds)
        } else {
          window.sessionStorage.removeItem("sfp-dealEnds")
        }
        if (!!this.sortKey) {
          window.sessionStorage.setItem("sfp-sortKey", this.sortKey)
        } else {
          window.sessionStorage.removeItem("sfp-sortKey")
        }
        if (this.sortStateOrder !== "") {
          window.sessionStorage.setItem("sfp-sortStateOrder", this.sortStateOrder)
        } else {
          window.sessionStorage.removeItem("sfp-sortStateOrder")
        }
      }
      this.$store.dispatch('FACILITY_SEARCH', {url: url, clear: clear, data: data, loadparams: loadparams, autocomplete: autocomplete, callback: callback, checkall: this.isCheckedAll})
    },
    /** 全施設選択 / クリア */
    selectAll: function (checked) {
      this.isCheckedAll = checked
      this.$store.dispatch('FACILITY_CHECKED', { checked: checked })
    },
    /** ソート */
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order
      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          if (key === 'age') {
            key = 'birthday' // 年齢は生年月日
            asc_desc = asc_desc === 'asc' ? 'desc' : 'asc' // 年齢は逆
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('patient_name_furigana asc')
      }
      return result.join(' , ')
    },
    // 店舗別担当施設表示
    goSurroundingSearchByShops: function() {
      if (this.overShopCount) {
        return
      }
      this.shopList.sort(function (a, b) {
        return a - b
      })
      var data = {
        'shop_list': this.shopList,
        'facility_all':        "0",
        'facility_person':     "1"
      }
      this.$store.dispatch('FACILITY_SHOP_LIST_SAVE', {data: this.shopList})
      this.$store.dispatch('FACILITY_SEARCH_BY_SHOP', {data: data, callback: () => {
        this.$router.push({ name: 'facilityPersonSurrounding', query: { type: this.$router.currentRoute.query.type, searchShops: true} })
      }})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/facility-person-list.js